<template>
  <svg
    :width="width ? width : height ? height * (42 / 32) : 42"
    :height="height ? height : width ? width * (32 / 42) : 32"
    viewBox="0 0 42 32"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <path
      d="M20.03 8.3L6.86 19.15v11.7C6.86 31.5 7.37 32 8 32l8-.02c.64 0 1.14-.51 1.14-1.14V24c0-.63.52-1.14 1.15-1.14h4.57c.63 0 1.14.5 1.14 1.14v6.83a1.14 1.14 0 0 0 1.15 1.15l8 .02c.63 0 1.14-.51 1.14-1.14V19.14L21.12 8.3a.87.87 0 0 0-1.09 0zm20.8 7.37l-5.97-4.92V.85A.86.86 0 0 0 34 0h-4a.86.86 0 0 0-.85.86v5.18L22.75.78a3.43 3.43 0 0 0-4.36 0L.31 15.68a.86.86 0 0 0-.11 1.2l1.82 2.22a.86.86 0 0 0 1.2.11L20.04 5.37a.87.87 0 0 1 1.1 0l16.8 13.84a.86.86 0 0 0 1.2-.11l1.83-2.22a.86.86 0 0 0-.13-1.2z"
      :fill="iconColor"
      fill-rule="nonzero"
    ></path>
  </svg>
</template>

<script>
export default {
  name: 'user',
  props: {
    iconColor: {
      type: String,
      default: '#ffffff',
    },
    height: {
      type: Number,
      required: false,
    },
    width: {
      type: Number,
      required: false,
    },
  },
};
</script>
